

























import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import { PlanDetailInformation } from "../../types";
import moment from "moment";
import * as _ from "lodash";
import * as RouteNames from "@/employer/route-names";
import Input from "@/shared/components/ui/Input.vue";
import RadioButton from "@/shared/components/ui/RadioButton.vue";
import Select from "@/shared/components/ui/Select.vue";
import Button from "@/shared/components/ui/Button.vue";
import PlanDetailEdit from "@/employer/components/profile/PlanDetailEdit.vue";
import ErrorSummary from "@/shared/components/ErrorSummary.vue";
import { useProfileStore } from "@/employer/store/profile";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    Input,
    RadioButton,
    Select,
    Button,
    PlanDetailEdit,
    ErrorSummary
  }
})
export default class PlanDetail extends Vue {

  profileStore = useProfileStore();
  userStore = useUserStore();


  isSubmitting = false;
  formModel: PlanDetailInformation[] = null;

  get employerId () { return this.forEmployerId || this.userStore.employerId; }

  @Prop({ required: false })
  forEmployerId: number;

  @Prop()
  employerName: string;

  @Prop()
  submitButtonText: string;

  @Prop()
  greyBackground: boolean;

  @Prop()
  fetchEnrollmentData: false;

  @Prop()
  isOnBoardingScreen: false;

  get submitText (): string {
    return this.submitButtonText ? this.submitButtonText : "Next";
  }

  @Watch("formModel", { deep: true })
  onFormModelChanged () {
    if (this.formModel && this.formModel.length) {
      if (!this.formModel[0].planStartDate) return;
      let prevYear = null;
      for (let i = 0; i < this.formModel.length; i++) {
        const planYear = this.formModel[i];
        if (planYear.planStartDate && !planYear.planEndDate) {
          // there is a future year use the start date to compute end date
          if ((i + 1) < this.formModel.length && this.formModel[i + 1].planStartDate) {
            planYear.planEndDate = moment(this.formModel[i + 1].planStartDate).subtract(1, "days").format("L");
          }
        }
        // A end date has been entered so calculate the next year
        if (prevYear && prevYear.planEndDate) {
          planYear.planStartDate = moment(prevYear.planEndDate).add(1, "days").format("L");
          planYear.planEndDate = moment(planYear.planStartDate).add(1, "years").subtract(1, "days").format("L");
        }

        prevYear = this.formModel[i];
      }
    }
  }

  @Watch("profileStore.planDetailInformation")
  onPlanStateChanged () {
    this.initializeFromStateValue();
  }

  get isLoaded () {
    return this.profileStore.planDetailInformationLoaded;
  }

  cloneToCurrentModel (o) {
    const clonedModel = o.map(d => {
      const model = _.cloneDeep(d);
      model.employerId = this.employerId;
      return model;
    });
    this.formModel = clonedModel;
  }

  initializeFromStateValue () {
    const employerPlanDetails = this.profileStore.planDetailInformation;
    if (this.formModel && this.formModel[0].planStartDate) {
      return;
    } else if (employerPlanDetails && employerPlanDetails.length) {
      this.cloneToCurrentModel(employerPlanDetails);
    }
  }

  mounted (): void {
    this.initializeFromStateValue();
    this.profileStore.getPlanDetailInformation(this.employerId);
    this.fetchEnrollment();
  }

  fetchEnrollment (): void {
    if (this.fetchEnrollmentData) {
      this.profileStore.loadEnrollmentMetrics(this.employerId);
    }
  }

  get suppressNotifierMessages (): boolean {
    // suppress notification from the notifier store for users in the onboarding flow

    return (this.$router.currentRoute.name === RouteNames.Onboarding ||
      this.$router.currentRoute.name === RouteNames.PartnerNewEmployer);
  }

  onSubmit (): void {
    const formModel: PlanDetailInformation[] = this.formModel.map(d => _.cloneDeep(d));
    this.validateAllScopes().then(result => {
      if (!result) {
        return;
      }
      this.isSubmitting = true;
      this.profileStore.savePlanDetailInformation({
        employerId: this.employerId,
        request: formModel,
        suppressNotifierMessages: this.suppressNotifierMessages
      })
        .then(resp => {
          this.isSubmitting = false;
        })
        .then(resp => this.$emit("complete"))
        .catch(err => this.isSubmitting = false);
    });
  }

  validateAllScopes (): Promise<boolean> {
    const scopeValidations = this.formModel.map((member, index) => this.$validator.validateAll(`${index}`));

    return this.$validator.validateAll().then(v => {
      if (!v) {
        return v;
      }
      return Promise.all(scopeValidations)
        .then(values => !values.some(validationResult => !validationResult));
    });
  }

  get submitDisabled () {
    return this.$validator.errors.any() || this.isSubmitting;
  }
}
